<script>
  import { inertia, page } from '@inertiajs/inertia-svelte'
  import { route } from '@/Utils'
</script>

{#if $page.props.pages.length !== 0}
  <div {...$$restProps}>
    {#each $page.props.pages as page (page.id)}
      <a class="px-2 text-center" use:inertia href={route('pages.display', {'name': page.name})}>
        <span class="text-xs">{page.title}</span>
      </a>
    {/each}
  </div>
{/if}
